var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-td-button-select-b2b"},[_c('MdtButtonSelect',{attrs:{"items":_vm.itemsTransformed,"size":"size-32","relative":""},on:{"buttonSelect":_vm.buttonSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }